import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __, _i } from "../../utils/i18n.js";
const RESTRICTION_LABELS = {
    par: _i(__("You cannot change {{strong}}parent{{/strong}} folder"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    rea: _i(__("You cannot {{strong}}rearrange{{/strong}} subfolders"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    cre: _i(__("You cannot {{strong}}create{{/strong}} subfolders"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    ins: _i(__("You cannot {{strong}}insert{{/strong}} new files. New files will be moved to Unorganized..."), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    ren: _i(__("You cannot {{strong}}rename{{/strong}} the folder"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    del: _i(__("You cannot {{strong}}delete{{/strong}} the folder"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    }),
    mov: _i(__("You cannot {{strong}}move{{/strong}} files outside the folder"), {
        strong: /*#__PURE__*/ _jsx("strong", {})
    })
};
function LockedToolTipText({ restrictions }) {
    let inheritsCount = 0;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            __("The current selected folder has some restrictions:"),
            /*#__PURE__*/ _jsx("br", {}),
            restrictions.map((r)=>{
                const inherits = r.slice(-1) === ">";
                const i18nKey = inherits ? r.slice(0, -1) : r;
                inherits && inheritsCount++;
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        "- ",
                        RESTRICTION_LABELS[i18nKey],
                        inherits && /*#__PURE__*/ _jsx("strong", {
                            children: " *"
                        })
                    ]
                }, r);
            }),
            inheritsCount > 0 && /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: "*"
                    }),
                    " ",
                    __("New folders inherit this restriction")
                ]
            })
        ]
    });
}
export { LockedToolTipText };
